import React, { useEffect } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { DataTypes } from "../../../../constants";

import {
    Card,
    CardActionArea,
    CardHeader,
    CardMedia,
    Container,
    Grid,
    Tooltip,
    Typography,
} from "@mui/material";
import BreadcrumbBuilder from "../BreadcrumbBuilder";
import Fetching from "../../../Common/Fetching";
import TMSAvatar from "../TMSAvatar";

import tmsActions from "../../../../actions/tmsActions";
import { getLibrary, isFetching } from "../../../../reducers";

const image =
    "https://cdn.premierit.com/images/banners/centric/bnr-cent_002.png";

const Library = ({ categories, isFetching, getLibrary }) => {
    useEffect(() => {
        getLibrary("C-TMS");
    }, [getLibrary]);

    return (
        <Container className="content">
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <BreadcrumbBuilder />
                </Grid>
                {isFetching && (
                    <Grid item xs={12}>
                        <Fetching />
                    </Grid>
                )}
                {!!categories &&
                    !!categories.length &&
                    categories.map((category) => (
                        <Grid item md={12} lg={6} xl={4} key={category.id}>
                            <Card className="card">
                                <CardActionArea
                                    component={Link}
                                    to={`/tms/library/${
                                        Number(category.id) || ""
                                    }`}
                                    centerRipple={true}
                                >
                                    <Tooltip
                                        title="Explore this category"
                                        placement={"bottom-end"}
                                        arrow={true}
                                    >
                                        <CardMedia
                                            component="img"
                                            height="250"
                                            image={
                                                category?.image
                                                    ? category.image
                                                    : image
                                            }
                                            alt={category?.name || ""}
                                        />
                                    </Tooltip>
                                    <CardHeader
                                        disableTypography={true}
                                        avatar={
                                            <TMSAvatar
                                                type="category"
                                                backgroundColor={
                                                    category?.colour
                                                }
                                            />
                                        }
                                        title={
                                            <Typography
                                                component="h2"
                                                className="card-header-title"
                                            >
                                                {category.name}
                                            </Typography>
                                        }
                                        subheader={
                                            <Typography
                                                component="h3"
                                                className="card-header-subtitle"
                                            >
                                                {category.courses} courses
                                            </Typography>
                                        }
                                    />
                                </CardActionArea>
                            </Card>
                        </Grid>
                    ))}
            </Grid>
        </Container>
    );
};

const mapStateToProps = (state) => ({
    categories: getLibrary(state),
    isFetching: isFetching(state, DataTypes.TMS_LIBRARY),
});

export default connect(mapStateToProps, { getLibrary: tmsActions.getLibrary })(
    Library
);
